@if (formReady$ | async; as fr) {
  @if (fr && sections?.size === 0 && !error && (showActivitySettings$ | async) === false) {
    <div class="empty">
      {{ 'NOTIFICATIONS.SETTINGS.NO_ACCESS' | translate }}
    </div>
  }
  @if (showActivitySettings$ | async) {
    @if (activitySettingsURL$ | async; as url) {
      <atlas-panel>
        <atlas-panel-content class="atlas-navbar__beta-notifications-container">
          <div class="atlas-navbar__beta-notifications-container__description">
            <div>
              <glxy-badge>{{ 'NOTIFICATIONS.SETTINGS.BETA' | translate }}</glxy-badge>
              <span
                class="atlas-navbar__beta-notification-container_description-text"
                [innerHtml]="'NOTIFICATIONS.SETTINGS.ACTIVITY_SETTINGS_DESCRIPTION' | translate: { url: url }"
              ></span>
            </div>
          </div>
        </atlas-panel-content>
      </atlas-panel>
    }
  }
  @for (typesByCategory of sections | keyvalue; track typesByCategory) {
    <atlas-panel>
      <atlas-panel-header>
        <atlas-panel-title>
          <button
            atlasIconButton
            (click)="clickCategoryIcon(typesByCategory.key, $event)"
            class="atlas-navbar__notifications-form__category-icon"
            >
            <i class="material-icons">
              {{ getCategoryIcon(typesByCategory.key) }}
            </i>
          </button>
          {{ typesByCategory.key | categoryKey | translate }}
        </atlas-panel-title>
        <atlas-panel-description>
          <span>
            {{ getCategoryEnabledState(typesByCategory.key) | translate }}
          </span>
          <div class="atlas-navbar__notifications-description__settings">
            <div class="atlas-navbar__notifications-description__settings__container">
              <span class="atlas-navbar__notifications-description__settings__container-items">
                {{ 'NOTIFICATIONS.SETTINGS.DESCRIPTION.ALL_EVENTS' | translate }}
              </span>
              <mat-icon
                class="atlas-navbar__notifications-description__settings__container-items"
                [atlasTooltip]="'NOTIFICATIONS.SETTINGS.DESCRIPTION.ALL_EVENTS_TOOLTIP' | translate"
                >
                info_outline
              </mat-icon>
            </div>
            <div class="atlas-navbar__notifications-description__settings__container">
              <span class="atlas-navbar__notifications-description__settings__container-items">
                {{ 'NOTIFICATIONS.SETTINGS.DESCRIPTION.ONLY_MY_EVENTS' | translate }}
              </span>
              <mat-icon
                class="atlas-navbar__notifications-description__settings__container-items"
                [atlasTooltip]="'NOTIFICATIONS.SETTINGS.DESCRIPTION.ONLY_MY_EVENTS_TOOLTIP' | translate"
                >
                info_outline
              </mat-icon>
            </div>
          </div>
        </atlas-panel-description>
      </atlas-panel-header>
      <atlas-panel-content>
        @for (t of typesByCategory.value; track t) {
          <section class="atlas-navbar__notifications-form__checkbox-section">
            <div class="atlas-navbar__notifications-form__form-field atlas-navbar__notifications-form__panel-content">
              <div>
                <div>{{ t.notificationTypeId | notificationTypeKey: 'name' | translate }}</div>
                <div class="atlas-navbar__notifications-form__description">
                  {{ t.notificationTypeId | notificationTypeKey: 'description' | translate }}
                </div>
              </div>
              <div class="atlas-navbar__notifications-form__options">
                <div class="atlas-navbar__notifications-form__option-container">
                  <span class="atlas-navbar__notifications-form__option-container__title">
                    {{ 'NOTIFICATIONS.SETTINGS.DESCRIPTION.ALL_EVENTS' | translate }}
                  </span>
                  <span class="atlas-navbar__notifications-form__option-container__options">
                    @for (medium of availableMedium | keyvalue; track medium) {
                      <atlas-checkbox
                        class="atlas-navbar__notifications-form__option"
                    [ngModel]="
                      checked.get(checkboxId('partner', t.notificationTypeId, medium.value)) &&
                      isMediumEnabled(typesByCategory.key, t.notificationTypeId, medium.value)
                    "
                        (ngModelChange)="checked.set(checkboxId('partner', t.notificationTypeId, medium.value), $event)"
                        [disabled]="!isMediumEnabled(typesByCategory.key, t.notificationTypeId, medium.value)"
                    [atlasTooltip]="
                      (getTranslationKeyForMedium(medium.value) | translate) +
                      ' ' +
                      ('NOTIFICATIONS.SETTINGS.UNAVAILABLE' | translate)
                    "
                        [atlasTooltipDisabled]="isMediumEnabled(typesByCategory.key, t.notificationTypeId, medium.value)"
                        >
                        {{ getTranslationKeyForMedium(medium.value) | translate }}
                      </atlas-checkbox>
                    }
                  </span>
                </div>
                <div class="atlas-navbar__notifications-form__settings-separator"></div>
                <div class="atlas-navbar__notifications-form__option-container">
                  <span class="atlas-navbar__notifications-form__option-container__title">
                    {{ 'NOTIFICATIONS.SETTINGS.DESCRIPTION.ONLY_MY_EVENTS' | translate }}
                  </span>
                  <span class="atlas-navbar__notifications-form__option-container__options">
                    @for (medium of availableMedium | keyvalue; track medium) {
                      <atlas-checkbox
                        class="atlas-navbar__notifications-form__option"
                    [ngModel]="
                      checked.get(checkboxId('user', t.notificationTypeId, medium.value)) &&
                      isMediumEnabled(typesByCategory.key, t.notificationTypeId, medium.value)
                    "
                        (ngModelChange)="checked.set(checkboxId('user', t.notificationTypeId, medium.value), $event)"
                        [disabled]="!isMediumEnabled(typesByCategory.key, t.notificationTypeId, medium.value)"
                    [atlasTooltip]="
                      (getTranslationKeyForMedium(medium.value) | translate) +
                      ' ' +
                      ('NOTIFICATIONS.SETTINGS.UNAVAILABLE' | translate)
                    "
                        [atlasTooltipDisabled]="isMediumEnabled(typesByCategory.key, t.notificationTypeId, medium.value)"
                        >
                        {{ getTranslationKeyForMedium(medium.value) | translate }}
                      </atlas-checkbox>
                    }
                  </span>
                </div>
              </div>
            </div>
          </section>
        }
      </atlas-panel-content>
    </atlas-panel>
  }
} @else {
  @if (!error) {
    <div class="atlas-navbar__loading">
      <atlas-loader [size]="24"></atlas-loader>
    </div>
  }
  @if (error) {
    <div class="atlas-navbar__empty">
      <div class="atlas-navbar__empty__icon">
        <i class="material-icons">error</i>
      </div>
      {{ 'NOTIFICATIONS.SETTINGS.LOAD_FAILURE' | translate }}
    </div>
  }
}

